
interface StoreConfig {
  country: string
  countryAbv: string
  state: string
  stateIdentifier: string
  city: string
  countryIdentifier: string
  restaurantId: string
  storeId: string
  location?: {
    lat: number
    lng: number
  }
}

function getDefaultStoreConfig(): StoreConfig {
 
  if (typeof window !== 'undefined' && window.StoreConfig) {
    const storeConfig = window.StoreConfig
    
    return {
      country: storeConfig.country || '',
      countryAbv: storeConfig.countryIdentifier || '',
      state: storeConfig.state || '',
      stateIdentifier: storeConfig.stateIdentifier || '',
      city: storeConfig.city || '',
      countryIdentifier: storeConfig.countryIdentifier || '',
      restaurantId: storeConfig.restaurantId || '',
      storeId: storeConfig.storeId || '',
      location: storeConfig.addressLocation ? {
        lat: storeConfig.addressLocation.lat,
        lng: storeConfig.addressLocation.long,
      } : undefined,
    }
  }
  

  return {
    country: '',
    countryAbv: '',
    state: '',
    stateIdentifier: '',
    city: '',
    countryIdentifier: '',
    restaurantId: '',
    storeId: '',
  }
}

const isProd = import.meta.env.VITE_APP_ENV === 'production'

export const config = {
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL ||
      (isProd
        ? 'https://api.nextorder.co'
        : 'https://api-dev.nextorder.co'),
    cloudFunctionsUrl: import.meta.env.VITE_CLOUD_FUNCTIONS_URL ||
      (isProd
        ? 'https://us-central1-next-order-prodenv.cloudfunctions.net'
        : 'https://us-central1-next-order-devenv.cloudfunctions.net'),
    storageBaseUrl: import.meta.env.VITE_STORAGE_BASE_URL ||
      (isProd
        ? 'https://storage.googleapis.com/next-order-media'
        : 'https://storage.googleapis.com/next-order-media-dev'),
  },
  addressSearch: {
    radius: import.meta.env.VITE_ADDRESS_SEARCH_RADIUS || '2000',
    types: import.meta.env.VITE_ADDRESS_SEARCH_TYPES
      ? import.meta.env.VITE_ADDRESS_SEARCH_TYPES.split(',')
      : ['street_address', 'premise', 'subpremise'],
  },
  store: getDefaultStoreConfig(),
} as const

export type Config = typeof config
